import {
    HttpLibrary,
    RequestContext,
    ResponseContext,
    from,
    Observable,
} from 'hotdesk_typescript';

/**
 * Marker header a caller can set to have the request dispatched with
 * `keepalive: true` — it never reaches the network. Needed by the beacon-style
 * requests fired from unmount/pagehide (the IWG quote-release), which must
 * outlive the page that started them. Set it through a middleware rather than
 * on the RequestContext directly, so the SDK's generated request factories
 * stay untouched.
 */
export const KEEPALIVE_HEADER = 'x-internal-keepalive';

export class HttpClientLibrary implements HttpLibrary {
    constructor() {}
    public send(request: RequestContext): Observable<ResponseContext> {
        const method = request.getHttpMethod().toString();
        const url = request.getUrl();
        const body = request.getBody();
        const headers = { ...request.getHeaders() };
        const keepalive = headers[KEEPALIVE_HEADER] === '1';
        delete headers[KEEPALIVE_HEADER];
        const resultPromise = fetch(url, {
          method: method,
          body: body as any,
          headers,
          credentials: 'omit',
          ...(keepalive && { keepalive: true })
        }).then((resp: any) => {
          const headers: { [name: string]: string } = {};
          resp.headers.forEach((value: string, name: string) => {
            headers[name] = value;
          });
          // Stash request metadata so middleware can attach it to errors/breadcrumbs.
          headers['x-internal-request-url'] = url;
          headers['x-internal-request-method'] = method;

          const respBody = {
            text: () => resp.text(),
            binary: () => resp.blob(),
          };
          return new ResponseContext(resp.status, headers, respBody);
        });

        return from<Promise<ResponseContext>>(resultPromise);
    }
}
